/**
 * Обработка закрытия/перезагрузки страницы браузера
 *
 * Управлять сообщением мы не можем - браузеры игнорируют. Достаточно просто выполнить return
 * чтобы браузер показал сообщение при выходе
 *
 *
 * @todo Следует доработать логику добавления условий !!!
 */

'use strict';
Fotobook.beforeUnload = {

    /** Условия */
    _conditionsStack: [],

    _runFunc: [],

    /**
     * Добавить новое условие
     *
     * @param callable Функция которая должна возвратить true/false. true - препятствовать закрытию окна.
     * @param runFunc Если callable == true, а runFunc определен то выполнить его
     */
    addCondition(callable, runFunc) {
        this._conditionsStack.push(callable);
        if (runFunc === undefined) {
            this._runFunc.push('');
        } else {
            this._runFunc.push(runFunc);
        }
    },

    /**
     * Проверка при закрытии страницы
     *
     * @returns {string}
     */
    checkOnBeforeUnload() {
        for (let i = 0; i <= this._conditionsStack.length - 1; i++) {
            if (this._conditionsStack[i]()) {
                // нет колбека, но страницу не перегружать - уведомление будет показано средствами браузера
                if (this._runFunc[i] === '') {
                    return ' ';
                } else {
                    if (this._runFunc[i]()) {
                        return ' ';
                    }
                }
            }
        }
    },

    /**  Очистить очередь условий */
    clearStack() {
        this._conditionsStack = [];
        this._runFunc = [];

        return true;
    },
};

/**
 * Добавляем событие
 */
$(window)
    .on('beforeunload', () => {
        return Fotobook.beforeUnload.checkOnBeforeUnload();
    });
